<template>
	<div class="flex flex-col max-w-full">
		<div class="min-h-screen flex bg-splash bg-cover md:bg-fixed">
			<div class="flex flex-col m-auto">
				<div class="text-6xl text-theme-600 font-bold align-left mx-0">Busline</div>
				<div class="text-4xl text-white">Never miss a bus again</div>
				<!-- <div>
					<button
						class="bg-theme-600 hover:bg-theme-400 text-white border-0 rounded-lg p-4 mt-6 text-2xl"
					>Get the app</button>
				</div>-->
			</div>
			<div class="my-auto mr-auto">
				<img src="../assets/Splash.png" class="splash hidden md:inline" />
			</div>
		</div>
		<div class="h-50v flex flex-col bg3 md:bg-fixed bg-cover">
			<div
				class="xxl:text-5xl text-4xl font-semibold mx-auto mt-16 text-center text-white"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				Built to tackle Bangalore's
				<br />most common problem
			</div>
			<div
				class="text-2xl xl:text-3xl xxl:text-4xl font-light mx-auto my-12 text-center text-gray-200 italic w-80"
				data-aos="fade-up"
				data-aos-duration="1800"
			>
				Ever tried to get around Bangalore, but couldn't find a bus? Tired of missing buses?
				Well, you're in luck because we got you covered! Introducing busline, an app that gives you realtime information on the city's local buses.
				Let's dive into some of its features
			</div>
		</div>
		<div class="h-75v flex md:flex-row flex-col bg-white">
			<div
				class="md:px-6 md:my-auto md:ml-auto md:mr-12 mx-auto pb-24 md:py-0 md:order-first order-last"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				<img src="../assets/Section1.png" class="max-xl xxl:max-50v" />
			</div>
			<div
				class="md:my-auto md:mr-auto md:ml-12 mx-12 my-24 text-2xl xxl:text-3xl max-w-3xl leading-snug"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				<span class="xxl:text-5xl text-3xl font-semibold leading-loose">
					Find and track buses near you
					<br />
				</span>
				Find buses near you and track them in realtime! With accurate and reliable bus information coming straight to your fingertips, you never have to miss a bus again!
			</div>
		</div>
		<div class="h-75v flex md:flex-row flex-col bg3 md:bg-fixed bg-cover text-white">
			<div
				class="md:px-6 md:my-auto md:mr-auto md:ml-12 mx-auto pb-24 md:py-0 order-last"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				<img src="../assets/Section2.png" class="max-xl xxl:max-50v" />
			</div>
			<div
				class="md:my-auto md:ml-auto md:mr-12 mx-12 my-24 text-2xl xxl:text-3xl max-w-3xl leading-snug"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				<span class="xxl:text-5xl text-3xl font-semibold leading-loose">
					All of the city's buses
					<br />
				</span>
				The city of Bangalore has over 7000 bus routes and all of them are now in the palm of your hand!
			</div>
		</div>
		<div class="h-75v flex md:flex-row flex-col bg-white">
			<div
				class="md:px-6 md:my-auto md:ml-auto md:mr-12 mx-auto pb-24 md:py-0 md:order-first order-last"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				<img src="../assets/Section3.png" class="max-xl xxl:max-50v" />
			</div>
			<div
				class="md:my-auto md:mr-auto md:ml-12 mx-12 my-24 text-2xl xxl:text-3xl max-w-3xl leading-snug"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				<span class="xxl:text-5xl text-3xl font-semibold leading-loose">
					Route and stop details
					<br />
				</span>
				Wanna know if a bus goes to where you want to go? We got your covered with route and stop details for all of the city's buses!
			</div>
		</div>
		<div class="h-75v flex md:flex-row flex-col bg3 md:bg-fixed bg-cover text-white">
			<div
				class="md:px-6 md:my-auto md:mr-auto md:ml-12 mx-auto pb-24 md:py-0 order-last"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				<img src="../assets/Section4.png" class="max-xl xxl:max-50v" />
			</div>
			<div
				class="md:my-auto md:ml-auto md:mr-12 mx-12 my-24 text-2xl xxl:text-3xl max-w-3xl leading-snug"
				data-aos="fade-up"
				data-aos-duration="1200"
			>
				<span class="xxl:text-5xl text-3xl font-semibold leading-loose">
					Search and Favorites
					<br />
				</span>
				- Search and find the routes you want!
				<br />- Add frequently travelled routes to your favorites for easy access!
			</div>
		</div>
		<div class="bg1 bg-cover py-32 md:inline hidden">
			<iframe
				class="mx-auto"
				width="800"
				height="450"
				src="https://www.youtube.com/embed/3PHzQROgikg"
				frameborder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		</div>
		<div class="bg1 bg-cover py-32 md:hidden inline">
			<iframe
				class="mx-auto"
				width="350"
				height="200"
				src="https://www.youtube.com/embed/3PHzQROgikg"
				frameborder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		</div>
		<div class="hidden md:inline">
			<div class="flex">
				<div class="pl-0 xl:pl-12 xxl:pl-48 xxl:-mr-12">
					<img src="../assets/portrait.png" class="max-50vh md:min-w-0 min-w-full max-w-full" />
				</div>
				<div class="my-auto mx-auto flex flex-col max-w-3xl">
					<div
						class="text-3xl xxl:text-5xl text-black mx-8 xxl:mx-0"
						data-aos="fade-up"
						data-aos-duration="2200"
					>By Hrishikesh Athreya</div>
					<div
						class="text-2xl xxl:text-3xl text-gray-600 mx-8 xxl:mx-0 mt-6"
						data-aos="fade-up"
						data-aos-duration="2200"
					>A motivated app developer from the city of Bangalore constantly on the lookout for new challenges. If you liked this app, check out my GitHub to look at some other cool things I've worked on. Send me an email if I look like someone you'd want to work with!</div>
					<div class="text-xl text-theme-600 text-right mt-12 pr-16 flex">
						<a href="mailto:hrishikesha40@gmail.com">
							<div class="mx-4 flex">
								<svg
									height="32px"
									fill="#5ed69f"
									class="mx-2"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									x="0px"
									y="0px"
									viewBox="0 0 1000 1000"
									enable-background="new 0 0 1000 1000"
									xml:space="preserve"
								>
									<g>
										<g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">
											<path
												d="M1232.5,3694.7c-465.2-26.9-813.1-253.7-1016.8-665.1c-123-248-119.2-107.6-113.4-2979.4l5.8-2610.3l51.9-144.2c124.9-340.2,403.7-617,742-734.3l128.8-44.2h3979h3979l132.6,51.9c349.8,142.2,601.6,397.9,726.6,745.8l44.2,125l5.8,2610.3c5.8,2871.8,9.6,2733.4-113.4,2983.3c-155.7,317.2-438.3,545.9-782.3,634.3c-109.6,28.8-486.3,32.7-3844.4,34.6C3110.5,3704.3,1344,3700.4,1232.5,3694.7z M8419.6,2779.7c-1.9-26.9-3337-2379.7-3367.7-2377.8C5025,403.9,1886,2766.2,1886,2785.5c0,3.8,1470.5,7.7,3267.7,7.7C6951,2793.2,8421.5,2787.4,8419.6,2779.7z M3024,765.2C4121.6-65.2,5026.9-743.7,5036.5-743.7c11.5,0,899.6,626.7,1976,1389.8l1956.8,1391.7l5.8-2222.1c3.8-2122.1,1.9-2224-30.8-2268.2c-19.2-26.9-59.6-65.4-88.4-86.5l-51.9-40.4H5000H1196l-51.9,40.4c-28.8,21.1-71.1,63.4-92.3,92.3c-40.4,51.9-40.4,63.4-46.1,2387.4c-1.9,1284,1.9,2333.6,9.6,2333.6C1024.9,2274.2,1928.3,1595.6,3024,765.2z"
											/>
										</g>
									</g>
								</svg> hrishikesha40@gmail.com
							</div>
						</a>
						<a href="https://github.com/Hrishikesh-Athreya" target="_blank">
							<div class="flex">
								<svg
									class="text-xl mx-2 -mb-4"
									fill="#5ed69f"
									role="img"
									viewBox="0 0 24 24"
									height="32px"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
									/>
								</svg>
								github.com/Hrishikesh-Athreya
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="md:hidden inline">
			<div class="min-h-screen max-h-screen flex flex-col bg2 bg-cover">
				<div
					class="sm:text-4xl text-3xl text-black mt-auto mx-12 bg-white p-2"
					data-aos="fade-up"
					data-aos-duration="2200"
				>By Hrishikesh Athreya</div>
				<div
					class="sm:text-2xl text-lg text-white mt-12 mb-auto mx-12 bg-black"
					data-aos="fade-up"
					data-aos-duration="2200"
				>A motivated app developer from the city of Bangalore constantly on the lookout for new challenges. If you liked this app, check out my GitHub to look at some other cool things I've worked on. Send me an email if I look like someone you'd want to work with!</div>
				<div class="text-xl text-theme-600 text-right mb-auto mx-auto pr-16 flex">
					<a href="mailto:hrishikesha40@gmail.com">
						<div class="mx-4 flex">
							<svg
								height="64px"
								fill="#fff"
								class="mx-2"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								x="0px"
								y="0px"
								viewBox="0 0 1000 1000"
								enable-background="new 0 0 1000 1000"
								xml:space="preserve"
							>
								<g>
									<g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">
										<path
											d="M1232.5,3694.7c-465.2-26.9-813.1-253.7-1016.8-665.1c-123-248-119.2-107.6-113.4-2979.4l5.8-2610.3l51.9-144.2c124.9-340.2,403.7-617,742-734.3l128.8-44.2h3979h3979l132.6,51.9c349.8,142.2,601.6,397.9,726.6,745.8l44.2,125l5.8,2610.3c5.8,2871.8,9.6,2733.4-113.4,2983.3c-155.7,317.2-438.3,545.9-782.3,634.3c-109.6,28.8-486.3,32.7-3844.4,34.6C3110.5,3704.3,1344,3700.4,1232.5,3694.7z M8419.6,2779.7c-1.9-26.9-3337-2379.7-3367.7-2377.8C5025,403.9,1886,2766.2,1886,2785.5c0,3.8,1470.5,7.7,3267.7,7.7C6951,2793.2,8421.5,2787.4,8419.6,2779.7z M3024,765.2C4121.6-65.2,5026.9-743.7,5036.5-743.7c11.5,0,899.6,626.7,1976,1389.8l1956.8,1391.7l5.8-2222.1c3.8-2122.1,1.9-2224-30.8-2268.2c-19.2-26.9-59.6-65.4-88.4-86.5l-51.9-40.4H5000H1196l-51.9,40.4c-28.8,21.1-71.1,63.4-92.3,92.3c-40.4,51.9-40.4,63.4-46.1,2387.4c-1.9,1284,1.9,2333.6,9.6,2333.6C1024.9,2274.2,1928.3,1595.6,3024,765.2z"
										/>
									</g>
								</g>
							</svg>
						</div>
					</a>
					<a href="https://github.com/Hrishikesh-Athreya" target="_blank">
						<div class="flex">
							<svg
								class="text-xl mx-2 -mb-4"
								fill="#fff"
								role="img"
								viewBox="0 0 24 24"
								height="64px"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
								/>
							</svg>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Layout"
};
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout.vue